export default function PageContent({ children }) {
    return (
        <div className="md:border-1 border-top-1 border-200 border-round-xl pt-4 md:p-4">
            {children}
        </div>
    );
}